import React from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import './list_event.css';
import { shortenText, formatProblemDisplay } from '../../../global/http_enum';

export default function ListEvent({ eventData, handleSelectEvent, handleOpenEvent, Selected, SetEditEvent, deleteEvent }) {
    return (
        <div
            onClick={() => handleSelectEvent(eventData)}
            onDoubleClick={() => handleOpenEvent(eventData)}
            className={`event-list ${Selected === eventData.id ? 'event-list-selected' : ''}`}
        >
            <div className="name-and-domain">
                <div className='event-name'>{eventData.name || 'Event Name'}</div>
                <div className='event-domain'>{eventData.domain || 'Domain'} Domain</div>
            </div>

            <div className="informations">
                <div>Location : {eventData.location ? shortenText(eventData.location, 40) : '...'}</div>
                <div>Problem : <span className='redt'>{eventData.problem_identifyed_from_event ? shortenText(formatProblemDisplay(eventData.problem_identifyed_from_event), 40) : '...'}</span> </div>
                <div>Negative Function : <span className='redt'>{eventData.negative_function_exluded ? shortenText(eventData.negative_function_exluded, 40) : '...'}</span></div>
            </div>
            <div className="actions">
                <div className='main-text-list'>
                    <DeleteIcon onClick={(e) => { e.stopPropagation(); deleteEvent(eventData.id); }} className='delete' />
                    <NoteAltIcon onClick={(e) => { e.stopPropagation(); SetEditEvent(eventData.id); }} className='edite' />
                </div>
            </div>
        </div>
    )
}
